import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Location } from '@angular/common';
import { SohoApplicationMenuComponent, SohoBusyIndicatorDirective, SohoBusyIndicatorEvent, } from 'ids-enterprise-ng';
import {
  AppConstants,
  LMBrowserUtilService,
  LMCommonUtilService,
  LMConditionUtilService,
  LMContextUtilService,
  LMGlobalUtilService,
  LMLocaleUtilService,
  LMUniqueIdService,
} from './utils';
import {
  LMAccessibleWebAppService,
  LMActionService,
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMCompoundFieldService,
  LMConfigurationService,
  LMContextService,
  LMDataService,
  LMDrillService,
  LMErrorUtilService,
  LMFieldUtilService,
  LMFileUploadService,
  LMFormatUtilService,
  LMGlobalPersistenceService,
  LMHarnessService,
  LMListFilterPersistenceService,
  LMLoggerService,
  LMPersonalizationPersistenceService,
  LMRelatedReportService,
  LMSpecService,
  LMStateHelperService,
  LMStatePersistenceService,
  LMUrlInfoBuilderService,
  LMUrlUtilService
} from './services';
import {
  LMFormPersonalizationService,
  LMFormStateService,
  LMGlobalPersonalization,
  LMGlobalPersonalizationService,
  LMGlobalState,
  LMGlobalStateService,
  LMGlobalStorageService,
  LMListPersonalizationService,
  LMListStateService,
  LMPagePersonalizationService,
} from './states';
import {
  LMActionFormDialogService,
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuHeaderComponentRef,
  LMApplicationMenuSearchComponent,
  LMApplicationMenuSearchService,
  LMApplicationMenuService,
  LMApplicationMenuTransactionService,
  LMApplicationMenuUserContextDialogService,
  LMBannerAsOfDateDialogService,
  LMBannerHeaderComponent,
  LMBannerHeaderComponentRef,
  LMBannerSearchService,
  LMBannerService,
  LMBannerTransactionService,
  LMBannerUserContextDialogService,
  LMCompactFormDialogService,
  LMComputeBuilderService,
  LMConfirmationMessageService,
  LMContextualActionPanelService,
  LMFieldPickerService,
  LMFormRequestService,
  LMFormSpecUtilService,
  LMHelperListDialogService,
  LMListActionUtilService,
  LMListContentFilterListUtilService,
  LMListGridPagingService,
  LMListGridUtilService,
  LMListTransactionService,
  LMListUtilService,
  LMLoginService,
  LMPrintDialogService,
  LMPrintRequestService,
  LMReportPersonalizationDialogService,
  LMResponseRequiredService,
  LMScheduleDialogService,
  LMSelectDialogService,
  LMSubFormDialogService
} from './components';
import { LMFormTransactionService } from '@form/services/lm-form-transaction.service';
import { LMTransactionService } from './transaction';

import * as _ from 'lodash';
import { SaveRequired } from '@base/lm-base';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMListActionFormDialogService } from '@list/services/lm-list-action-form-dialog.service';
import { LMBannerNavComponent } from '@banner/lm-banner-nav.component';
import { LMPageStateService } from '@states/services/lm-page-state.service';
import { LMPageSpecUtilService } from '@page/lm-page-spec-util.service';
import { LMListSpecUtilService } from '@list/index';
import { LMBannerMenuService } from '@banner/lm-banner-menu.service';
import { LMAuditLogService } from '@services/lm-audit-log.service';
import { LMToolbarServiceAdapter } from '@toolbar/lm-toolbar-service-adapter';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { LMBannerSearchComponent } from '@banner/lm-banner-search.component';
import { LMListContentFilterListService } from '@list/services/lm-list-content-filterlist.service';
import { LMFieldOptionsToolbarService } from '@field/services';
import { LMColorId, LMThemeId, LMThemeService } from '@banner/lm-theme.service';
import { Router } from '@angular/router';
import { LMFilterBuilderService } from '@modal/filter-builder/services/lm-filter-builder.service';
import { UserWebRequestHttpInterceptor } from './http.intercepter';
import { LMHttpIntercepterService } from '@services/lm-http-intercepter.service';
import { LMLplEditorService } from '@lplEditor/lm-lpl-editor.service';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';
import { LMCubeCellRelService } from '@modal/cube-cell-rel/services';
import { LMFieldValidatorService } from '@modal/lm-field-validator.service';
import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { LMProcessIndicatorService } from './components/field/processindicator/lm-process-indicator.service';
import { LMProcessIndicatorTooltipPipe } from './components/field/processindicator/lm-process-indicator-tooltip.pipe';
import { LMApplicationMenuComponent } from '@components/applicationmenu/menu';
import { LMApplicationMenuSubMenuService } from '@components/applicationmenu/submenu';
import { LMBusclassFieldService } from '@components/field/busclassfield/lm-busclassfield.service';
import { LMCaptchaControlService } from '@field/captchacontrol/lm-captcha-control.service';
import { LMListDropdownService } from '@components/lmlistdropdown';
import { LMAppComponentService } from '@utils/lm-app-component.service';

export const appComponentProviders: any[] = [
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuHeaderComponentRef,
  LMApplicationMenuSubMenuService,
  LMApplicationMenuTransactionService,
  LMApplicationMenuService,
  LMApplicationMenuSearchService,
  LMApplicationMenuUserContextDialogService,
  LMRouteComponentService,
  LMHarnessService,
  LMAccessibleWebAppService,
  LMActionFormDialogService,
  LMActionService,
  LMAuditLogService,
  LMBannerAsOfDateDialogService,
  LMBannerHeaderComponentRef,
  LMBannerMenuService,
  LMBannerTransactionService,
  LMBannerService,
  LMBannerSearchService,
  LMBannerUserContextDialogService,
  LMGlobalPersonalizationService,
  LMGlobalStateService,
  LMBrowserUtilService,
  LMBusyIndicatorService,
  LMCommonUtilService,
  LMCompactFormDialogService,
  LMCompoundFieldService,
  LMAppComponentService,

  LMConditionUtilService,
  LMConfirmationMessageService,
  LMContextUtilService,
  LMDataService,
  LMDrillService,
  LMErrorUtilService,
  LMContextualActionPanelService,

  LMFieldOptionsToolbarService,
  LMFieldUtilService,

  LMFieldPickerService,
  LMFilterBuilderService,

  LMFileUploadService,

  LMFormatUtilService,
  LMFormPersonalizationService,
  LMFormRequestService,
  LMFormSpecUtilService,
  LMFormStateService,
  LMFormTransactionService,

  LMGlobalPersonalizationService,
  LMGlobalStateService,
  LMGlobalStorageService,
  LMGlobalUtilService,
  LMHelperListDialogService,
  LMKeyboardShortcutService,

  LMContextualActionPanelService,
  LMListActionUtilService,
  LMListActionFormDialogService,
  LMListContentFilterListService,
  LMListContentFilterListUtilService,
  LMListGridPagingService,
  LMListGridUtilService,
  LMListPersonalizationService,
  LMListSpecUtilService,
  LMListStateService,
  LMListTransactionService,
  LMListUtilService,

  LMLocaleUtilService,
  LMLoggerService,
  LMLoginService,
  LMGlobalPersistenceService,
  LMNavigationService,

  LMPagePersonalizationService,
  LMPageSpecUtilService,
  LMPageStateService,

  LMPersonalizationPersistenceService,
  LMPrintDialogService,
  LMPrintRequestService,
  LMReportPersonalizationDialogService,
  LMResponseRequiredService,
  LMScheduleDialogService,
  LMSelectDialogService,
  LMSpecService,
  LMStatePersistenceService,
  LMStateHelperService,
  LMSubFormDialogService,
  LMToolbarServiceAdapter,
  LMThemeService,
  LMUrlInfoBuilderService,
  LMTransactionService,
  LMUrlUtilService,
  LMConfigurationService,
  LMRelatedReportService,
  LMComponentInfoService,
  LMUniqueIdService,
  UserWebRequestHttpInterceptor,
  LMLplEditorService,
  LMListDropdownService,
  LMCubeCellRelService,
  LMFieldValidatorService,
  LMComputeBuilderService,
  LMProcessIndicatorService,
  LMProcessIndicatorTooltipPipe,
  LMBusclassFieldService,
  LMCaptchaControlService,
  LMListFilterPersistenceService
];

export interface AppMenuComponent {
  version: 'v1' | 'v2';
  component: LMBannerNavComponent | LMApplicationMenuComponent;
  header: ElementRef;
  // eslint-disable-next-line @typescript-eslint/ban-types
  loadWebAppMenu: Function;
  menuSpecs: Array<any>;
}

export interface AppMenuSearchComponent {
  version: 'v1' | 'v2';
  component: LMBannerSearchComponent | LMApplicationMenuSearchComponent;
}

@Component({
  selector: 'lm-app',
  styleUrls: [ 'app.component.scss' ],
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild(LMBaseComponent) private baseComponent: LMBaseComponent;
  @ViewChild('SohoApplicationMenu') private sohoApplicationMenuComponent: SohoApplicationMenuComponent;
  @ViewChild('SohoApplicationMenuSearch') private sohoApplicationMenuSearchComponent: SohoApplicationMenuComponent;
  @ViewChild(LMBannerHeaderComponent) private _bannerHeaderComponent: LMBannerHeaderComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) sohoBusyIndicator: SohoBusyIndicatorDirective;
  @ViewChild(LMBannerNavComponent) private _bannerNavComponent: LMBannerNavComponent;
  @ViewChild(LMApplicationMenuComponent) private applicationMenuComponent: LMApplicationMenuComponent;
  @ViewChild(LMBannerSearchComponent) private _bannerSearchComponent: LMBannerSearchComponent;
  @ViewChild(LMApplicationMenuSearchComponent) private applicationMenuSearchComponent: LMApplicationMenuSearchComponent;

  @ViewChild('dialogPlaceholder', { read: ViewContainerRef, static: true }) placeHolder: ViewContainerRef;
  @ViewChild('fullmaincontent', { read: ViewContainerRef, static: true }) fullmaincontent: ViewContainerRef;

  @HostBinding('class.no-scroll') get disallowOverflow() {
    return this.noScroll;
  };

  @HostBinding('class.modal-engaged') get modalEngaged() {
    return this.showOverlay;
  };

  @HostBinding('class.harness_3_5') get xiHarness() {
    return !this.isXiHarness;
  };

  @HostBinding('class.hasHeaderTabs') get headerTabs() {
    return this.hasHeaderTabs;
  };

  @HostListener('window:beforeunload', [ '$event' ]) beforeUnloadHander(event) {
    // let dialogText = 'Dialog text here';
    //  event.returnValue = dialogText;
    console.log('@HostListener("window:beforeunload)"');
    const component: SaveRequired = this.getRouteComponent();
    // todo sjw lets use an interface here that the top level components must implement.
    // todo sjw saveComponentState isn't generic enough, maybe componentWillUnload()??
    if (component) {
      component.saveComponentState(true);
      const isSave = !component.checkSaveRequired();
      return isSave;
    } else {
      // when component is null, since it's not a router outlet like access denied, returns true so the dialog is not prompted
      return true;
    }
  }

  @HostListener('document:keydown', [ '$event' ]) onKeyDown(e) {
    // TODO check to make sure a modal isn't open.
    if (!this.hideAppMenu) {
      const key = this.lmKeyboardShortcutService.onKeyDown(e);
      if (!key) {
        return;
      }

      if (key === LMKeyType.MENU) {
        if (this.sohoApplicationMenuSearchComponent && this.sohoApplicationMenuSearchComponent.isOpen()) {
          this.menuSearchMode = false;
          this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
          this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);
        } else {
          if (this.sohoApplicationMenuComponent.isOpen()) {
            this.openOnLarge = false;
            this.sohoApplicationMenuComponent.closeMenu();
          } else {
            this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
            // LMCLIENT-29807 appear to be hitting a timing issue when doing the openMenu. added setTimeout().
            this.ngZone.runOutsideAngular(() => {
              setTimeout(() => {
                this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);
              }, 1);
            });
          }
        }
      }
    }
  }

  private showOverlay = false;
  private noScroll = true;

  public hideAppMenu = false;
  public hideTitle = false;
  public inMingleInbox = false;
  public inMingleWidget = false;
  public isXiFull = false;
  public isXiHarness = false;
  public is3xHarness = false;
  public hasHeaderTabs = false;
  public webAppsLoaded = false;
  public accessibleWebApps: LMWebAppSpec[];
  public searchString: string;
  public localeLoaded = false;
  public menuSearchMode = false;
  public menuSearchResultsByWebApp: LMBannerSearchResults;
  public dataSearchResults: Array<LMBannerSearchResult>;
  public reportSearchResults: Array<LMBannerSearchResult>;
  public menuSpecsByWebApp: Array<any>;  // todo: type me!
  public inUpliftTheme = false;
  public asOfDate: string;
  public showDeletedRecords: boolean;
  public useFullPageScrolling = false;
  private fPSChanged = false;
  private m_useFPScrolling = false;
  public showViewMoreNav = false;
  public onMobile = true;
  public openOnLarge;
  public uiLoadingIndicatorTimeout = 0;
  public applyColorToMenu = true;
  public bannerInRoute = false;

  /**
   *  V1 = Original banner menu
   *  v2 = New application menu
   */
  public menuIsV1 = false;
  public menuIsV2 = false;

  public skipToMainContentLabel = 'skip to main content'; // todo i18n me!

  private globalState: LMGlobalState;
  private lmKeyDownObservable: Observable<Event>;
  private takeUntilSubject$: Subject<void>;

  constructor(
    private location: Location,
    private ngZone: NgZone,
    private router: Router,
    private lmAccessibleWebAppService: LMAccessibleWebAppService,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmContextService: LMContextService,
    private lmContextUtilService: LMContextUtilService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmHarnessService: LMHarnessService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private currentComponent: LMRouteComponentService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmGlobalStateService: LMGlobalStateService,
    private lmLoggerService: LMLoggerService,
    private lmThemeService: LMThemeService,
    private lmKeyboardShortcutService: LMKeyboardShortcutService,
    private lmHttpIntercepterService: LMHttpIntercepterService,
    private lmBrowserUtilService: LMBrowserUtilService,
    private lmBannerService: LMBannerService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmApplicationMenuService: LMApplicationMenuService,
    private lmAppComponentService: LMAppComponentService
  ) {
    this.menuIsV1 = this.lmContextService.isApplicationMenuV1();
    this.menuIsV2 = this.lmContextService.isApplicationMenuV2();

    // Method Cypress will call
    if ((window as any).Cypress) {
      (window as any).cypressNavigateByUrl = (url: string) => this.cypressNavigateByUrl(url);
    }

    // --------------------------------------------------------------------
    // bootstrap values sent in the html file into a these services.
    // This allows us to mock these services for testing.
    // --------------------------------------------------------------------
    this.lmBusyIndicatorService.appComponent = this;

    this.lmUrlUtilService.setBannerSpecUrlTemplate(bannerSpecUrl);
    this.lmUrlUtilService.setAccessibleWebAppsUrlTemplate(accessibleWebAppsUrl);

    this.hideAppMenu = this.lmContextService.inMingleWidget() || this.lmContextService.inMingleInbox() || this.lmContextService.isHideMenuBar();
    this.hideTitle = this.lmContextService.isHideTitlebar();
    this.isXiFull = this.lmHarnessService.isXiFull();
    this.isXiHarness = this.lmHarnessService.isXiHarness();
    this.is3xHarness = this.lmHarnessService.is3xHarness();
    this.inMingleWidget = this.lmContextService.inMingleWidget();
    this.inMingleInbox = this.lmContextService.inMingleInbox();
    this.onMobile = this.lmContextService.isMobileDevice();
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;
    this.bannerInRoute = this.lmContextService.isBannerInRoute();

    // load global state here as getInitialAsOfDate needs it.
    this.loadGlobalState();

    // get the initial as of date based on the bootstrap html context object
    // or the as of date in global state.
    this.asOfDate = this.getInitialAsOfDate();
    this.checkAsOfDateInPast(this.asOfDate);
    this.setupShowDeletedRecords();

    // todo refactor asof date once the new spec urls are solely in place.
    //  once we refactor to only send a asofdate (and not a csk.asofdate) on data urls,
    //  we should only need to the commented code below to deal with the initial setting
    //  of the asofdate from the bootstrap global context
    // // If asofdate is set it means it came in from a url param through the bootstrap global context.
    // // in that case replace the url in the history so csk.asofdate is no longer on it.
    // // We need this to avoid the user being able to go back to a url that has as of date set on it.
    // const newUrl = this.lmUrlUtilService.removeParam(window.location.href, AppConstants.PARAM_CSK_ASOFDATE);
    // this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(newUrl));

    // todo refactor asof date once the new spec urls are solely in place.
    //  this code shoudl not be needed once we refactor to only send a asofdate
    //  (and not a csk.asofdate) on data urls.
    // ensure that csk.asofdate is always removed from the browser
    // url when using server side generated spec urls

    this.location.onUrlChange(url => {
      if (this.lmUrlUtilService.hasParam(url, AppConstants.PARAM_CSK_ASOFDATE)
      ||  this.lmUrlUtilService.hasParam(url, AppConstants.PARAM_CSK_SHOWDELETEDRECORDS)) {
        const newUrl = this.lmUrlUtilService.removeParams(url, [ AppConstants.PARAM_CSK_ASOFDATE, AppConstants.PARAM_CSK_SHOWDELETEDRECORDS ]);
        this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(newUrl));
      }

      if (!this.hideAppMenu) {
        this.syncWebappMenu(url);
      }
    });

    const options = [
      ...(this.isXiHarness ? [ 'isXiHarness', true ] : []),
      ...(this.is3xHarness ? [ 'is3xHarness', true ] : []),
      ...(this.inMingleWidget ? [ 'inMingleWidget', true ] : [])
    ];

    this.lmLoggerService.log([ 'Starting Infor Landmark Xi', new Date(), ... options ]);

    if (this.inMingleWidget) {
      document.getElementsByTagName('body')[ 0 ].classList.add('in-mingle-widget');
    }

    if (this.lmContextService.inMingle()) {
      this.takeUntilSubject$ = new Subject<void>();
    }

    // ------------------------------------------------------------
    // lmUrlUtilService must have the accessibleWebAppurl set
    // before this can be called.
    // ------------------------------------------------------------
    this.lmAccessibleWebAppService.getAccessibleApps().subscribe((response: any) => {
      this.lmContextService.setAccessibleWebApps(response);
      try {
        this.lmContextService.getCurrentWebAppSpec();
        this.webAppsLoaded = true;
      } catch (e) {
        this.lmErrorUtilService.showAccessDeniedError(e, this.placeHolder);
      }
    },
    (error: any) => {
      this.lmErrorUtilService.handleUnexpectedError(error, this.placeHolder);
    });

    this.lmHttpIntercepterService.run(this.lmContextService.getContext());
    this.lmAppComponentService.setAppComponent(this);
  }

  public cypressNavigateByUrl(url: string) {
    this.ngZone.run(() => {
      // this.lmGlobalUtilService.navigate(url)
      this.router.navigateByUrl(url);
    });
  }

  /**
   * returns an initial as of date of either what's passed into the bootstrap
   * html through a csk.asofdate param or what's in the LMGlobalState object.
   * If the date of the csk doesn't match teh date of globalstate object then
   * the csk will be used and the global state will be updated.
   */
  private getInitialAsOfDate(): string {
    const ctxAsOfDate = this.lmContextService.getAsOfDate();

    // ------------------------------------------------------------------
    // if state is disabled then never use the asofdate from state.
    // ------------------------------------------------------------------
    if (this.lmContextService.disablePageState()) {
      return ctxAsOfDate || '';
    }

    // ------------------------------------------------------------------
    // if there is an asofdate in the context then use that.
    // ------------------------------------------------------------------
    if (ctxAsOfDate) {
      if (!this.globalState.asOfDate || this.globalState.asOfDate !== ctxAsOfDate) {
        // ------------------------------------------------------------------
        // if there is not a globalState AsOfDate ore  it doesn't match
        // the ctxAsOfDate then update the globalState with the new value
        // ------------------------------------------------------------------
        this.globalState.asOfDate = ctxAsOfDate;
        this.saveGlobalState();
      }
      return ctxAsOfDate;
    }

    // ------------------------------------------------------------------
    // if not in the context but in global state then use that.
    // ------------------------------------------------------------------
    if (this.globalState.asOfDate) {
      this.lmContextService.setAsOfDate(this.globalState.asOfDate);
      return this.globalState.asOfDate;
    }

    return '';
  }

  /**
   * returns an initial showRecordsDoNotExist of either what's passed into the bootstrap
   * html through a csk param or what's in the LMGlobalState object.
   */
  private setupShowDeletedRecords() {
    if (!this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ShowDeletedRecords)) {
      return false;
    }

    this.showDeletedRecords = this.globalState.showdeletedrecords;
    this.lmContextService.setShowDeletedRecords(this.showDeletedRecords);
  }

  ngOnInit() {
    this.setPersonalizations();
    this.searchString = Soho.Locale.translate('Search');
  }

  ngAfterViewInit() {
    /**
     * ngAfterViewInit is executed outside the angular zone.
     * Must be placed in a timeout so that an openOnLarge change will
     * get picked up by change detection.
     */
    setTimeout(() => this.setMenuPersonalization());

    /**
     * hookup the app menu trigger once the afterViewInit is called. This will
     * ensure that the lm-toolbar has had a chance to create the application-menu-trugger
     * button.
     */
    if (!this.inMingleWidget && this.sohoApplicationMenuComponent && !this.lmContextService.isHideMenuBar()) {
      this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
    }

    if (this.lmBrowserUtilService.isIE11 && !this.lmContextService.inMingle()) {
      const title = Soho.Locale.translate('UnsupportedBrowser');
      const message = Soho.Locale.translate('UnsupportedBrowserMsg');
      this.lmGlobalUtilService.displayToastMessage(title, message, 'UnsupportedBrowser');
    }

    // LMRK-102637: Listen to keydown to set mingle activity cookie (recruiter taking notes during interview, no new requests)
    // LMWEB-2494: Mingle activity cookie will be updated in http interceptor as well (for users that are just browsing)
    if (this.lmContextService.inMingle()) {
      this.lmKeyDownObservable = fromEvent(document, 'keypress');
      this.lmKeyDownObservable.pipe(takeUntil(this.takeUntilSubject$), debounceTime(3000)).subscribe(() => {
        this.lmContextService.setMingleActivityCookie();
      });
    }
  }

  ngAfterViewChecked() {
    if (this.fPSChanged) {
      this.fPSChanged = false;

      if (this.useFullPageScrolling !== this.m_useFPScrolling) {
        setTimeout(() => this.useFullPageScrolling = this.m_useFPScrolling, 1);
      }
    }
  }

  ngOnDestroy(): void {
    this.lmThemeService.getThemeChangeSubject().unsubscribe();
    if (this.lmContextService.inMingle()) {
      this.takeUntilSubject$.next();
      this.takeUntilSubject$.complete();
    }
  }

  getRouteComponent(): any {
    return this.currentComponent.getRouteComponent();
  }

  public onActivate(component) {
    const url = this.router.url;

    if (this.inMingleWidget && (url.indexOf('nav=') >= 0 || url.indexOf('/list/') >= 0)) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.showViewMoreNav = true;
        }, 1);
      });
    }
  }

  public onMenuLoaded(event: MouseEvent) {
    this.sohoApplicationMenuComponent.updateLazy(this.sohoApplicationMenuComponent, event.target);
  }

  public onWebAppMenuLoaded(roleSwitcherMode: boolean) {
    const applicationMenu = this.sohoApplicationMenuComponent;
    const webAppMenuHeader = this.getMenuComponent().header;

    if (webAppMenuHeader) {
      this.expandPreviouslyOpenedMenus();

      if (!webAppMenuHeader.nativeElement.classList.contains('is-expanded')) {
        this.sohoApplicationMenuComponent.toggleAndSelectHeader(applicationMenu, webAppMenuHeader.nativeElement);
      }
    } else {
      if (roleSwitcherMode) {
        this.sohoApplicationMenuComponent.updated();
        this.expandPreviouslyOpenedMenus();
      }
    }
  }

  private expandPreviouslyOpenedMenus() {
    const expandedMenus = this.lmBannerService.getExpandedMenus();

    if (expandedMenus && expandedMenus.length > 0) {
      expandedMenus.forEach((menuIndex) => {
        // TODO: move to ids-enterprise-ng
        const accordionElement = jQuery(`[menuindex='${menuIndex}']`);

        if (!accordionElement.data('accordion')) {
          this.ngZone.runOutsideAngular(() => accordionElement.accordion());
        }

        const accordionControl = accordionElement.data('accordion');
        if (accordionControl) {
          this.ngZone.runOutsideAngular(() => accordionControl.expand(accordionElement, true));
        }

        if (accordionElement.attr('selected')) {
          this.ngZone.runOutsideAngular(() => accordionControl.select(accordionElement));
        }
      });
    }
  }

  public onMenuVisibility(visible: boolean) {
    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    bannerPersonalization.isMenuOpen = visible;
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(bannerPersonalization);
  }

  public onAccordionExpand(result: any) {
    if (result) {
      const menuHeader = result[0];
      const webAppName  = menuHeader.getAttribute('web-app-name');

      if (webAppName) {
        this.getMenuComponent().component.loadWebAppMenu(menuHeader);
      }
    }
  }

  public onSearchMenuVisibility() {
    if (!this.sohoApplicationMenuSearchComponent.isOpen()) {
      this.menuSearchMode = false;
      this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
    }
  }

  private updateThemeIcons(themeId: LMThemeId) {
    if (this.lmThemeService.isUpliftTheme(themeId)) {
      this.inUpliftTheme = true;
    } else {
      this.inUpliftTheme = false;
    }
  }

  public onAsOfDateChanged(date: string) {
    if (date === '' || date === '00000000') {
      this.onAsOfDateCleared();
      return;
    }
    this.lmContextService.setAsOfDate(date);
    this.checkAsOfDateInPast(date);
    this.asOfDate = date;

    this.globalState.asOfDate = date;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    // force a reload of the route so that asofdate can be taken into
    // account by the route component (List, Form, Page, etc...).
    this.forceLocationReload();
  }

  private checkAsOfDateInPast(date: string): void {
    // only check if asOfDate in past if asOfDate is set
    if (!date || date.toString().length === 0) {
      return;
    }
    const today = new Date();
    // Need to get the date object from Soho.Locale.parseDate, otherwise the locale isn't taken into account
    // and new Date returns an invalid when not in USA date format
    const asOfDate = Soho.Locale.parseDate(this.lmFormatUtilService.yyyymmddToDisplay(date));
    if (asOfDate < today) {
      this.lmContextService.setAsOfDateInPast(true);
    } else {
      this.lmContextService.setAsOfDateInPast(false);
    }
  }

  public onAsOfDateCleared() {
    this.lmContextService.clearAsOfDate();
    this.lmContextService.setAsOfDateInPast(false);
    this.asOfDate = '';

    delete this.globalState.asOfDate;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    // force a reload of the route so that asofdate can be taken into
    // account by the route component (List, Form, Page, etc...).
    this.forceLocationReload();
  }

  public showDeletedRecordsCleared() {
    this.showDeletedRecordsChanged(false);
  }

  public showDeletedRecordsChanged(on: boolean) {
    this.lmContextService.setShowDeletedRecords(on);
    this.globalState.showdeletedrecords = on;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    // force reload of the route so that showdeleterrecords can be taken into
    // account by the route component (List, Form, Page, etc...).
    // this.forceLocationReload();
    this.lmGlobalUtilService.navigate(window.location.href, null, 'replace');
  }

  private forceLocationReload(): void {
    this.lmGlobalUtilService.navigateByUrl(window.location.href, { replaceUrl: true });
  }

  public fullPageScrolling(useFPS: boolean) {
    this.fPSChanged = true;
    this.m_useFPScrolling = useFPS;
  }

  public onMenuSearched(event: LMBannerSearchEvent) {
    this.menuSearchMode = true;
    this.menuSpecsByWebApp = event.menuSpecsByWebApp;
    this.menuSearchResultsByWebApp = event.menuSearchResultsByWebApp;
    this.dataSearchResults = event.dataSearchResults;
    this.reportSearchResults = event.reportSearchResults;
    this.searchString = event.searchString;

    // no need for change detection here. put setTimeout
    // outside Angular so change detection won't be fired.
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.sohoApplicationMenuComponent.closeMenu();
        this.sohoApplicationMenuSearchComponent.openMenu(undefined, true, undefined);

        const applicationMenuSearch = this.sohoApplicationMenuSearchComponent;
        const searchMenuHeaders = this.getSearchMenuComponent().component.searchMenuHeaders;
        if (searchMenuHeaders) {
          const header = searchMenuHeaders.toArray()[ 0 ];
          if (header) {
            if (this.isHeaderExpanded(header)) {
              this.sohoApplicationMenuSearchComponent.updated();
            } else {
              this.sohoApplicationMenuSearchComponent.toggleAndSelectHeader(applicationMenuSearch, header.nativeElement);
            }
          }
        } else {
          this.sohoApplicationMenuSearchComponent.updated();
        }
      });
    });
  }

  public onMenuSearchCleared() {
    this.menuSearchMode = false;
    this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
    this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);

    this.menuSearchResultsByWebApp = {};
    this.dataSearchResults = [];
    this.reportSearchResults = [];
    this.getMenuComponent().menuSpecs = [];

    if (this.lmBannerService.getExpandedMenus() && this.lmBannerService.getExpandedMenus().length > 0) {
      this.lmBannerService.getExpandedMenus().forEach((menuIndex) => {
        this.ngZone.runOutsideAngular(() => {
          /**
           * TODO: Create ids-enterprise example for dynamically adding/removing HTML from the Application menu...
           * Timeout because of a timing conflict with ids-enterprise Application menu control
           * when search closes or opens the application menu, it then causes updateRequired to be flagged in ids-enterprise-ng wrapper
           * this then triggers an update event "this.applicationmenu.updated()" in ngAfterViewChecked(),
           * update then does a full rebuild of the application menu, which causes the panes to rebuild/toggle when they are already open
           */
          setTimeout(() => {
            const lmBannerMenuElement = document.querySelectorAll('[menuindex="' + menuIndex + '"]')[0]?.nextElementSibling as HTMLElement;
            if (lmBannerMenuElement) {
              lmBannerMenuElement.style.height = 'auto';
            }
          }, 1);
        });
      });
    }
  }

  public onBusyComplete(event: SohoBusyIndicatorEvent) {
    // this.lmLoggerService.log([ this, 'onBusyComplete()', event ]);
  }

  roleSelected() {
    this.lmBannerService.clearExpandedMenus();
    this.sohoApplicationMenuComponent.closeSwitcherPanel();
  }

  private setPersonalizations() {
    const globalPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    this.lmThemeService.getThemeChangeSubject().subscribe(themeId => {
      const id = themeId ? themeId: globalPersonalization.theme;
      this.updateThemeIcons(id as LMThemeId);
    });

    const accessibilityMode = globalPersonalization.accessibilityMode === undefined ? true : globalPersonalization.accessibilityMode;
    this.applyColorToMenu = globalPersonalization.applyColorToMenu;
    const useCompactFormLayout = globalPersonalization.useCompactFormLayout === undefined ?
      this.lmContextService.getCompactnessMode() === 'compact' : globalPersonalization.useCompactFormLayout;

    const context = this.lmContextService.getContext();
    if (context.theme || context.color) { // Use ming.le/portal theme/color if it exits and isn't default
      let theme = globalPersonalization.theme;
      let color = globalPersonalization.color;
      if (context.theme && context.theme !== 'Light') {
        theme = context.theme as LMThemeId;
      }
      if (context.color && context.color !== 'default') {
        color = context.color as LMColorId;
      }
      this.lmThemeService.setThemeAndColor(theme as LMThemeId, color as LMColorId, useCompactFormLayout);
    } else {
      this.lmThemeService.setThemeAndColor(globalPersonalization.theme, globalPersonalization.color, useCompactFormLayout);
    }

    // if not in Ming.le/Portal and theme/color were never set, then set them to what setThemeAndColor chose by default
    if (!context.theme) {
      if (context.theme || this.lmThemeService.isCurrentThemeDefault()) {
        delete globalPersonalization.theme;
      } else {
        globalPersonalization.theme = this.lmThemeService.getCurrentThemeId();
      }
    }
    if (!context.color) {
      globalPersonalization.color = this.lmThemeService.getCurrentColorId();
    }
    globalPersonalization.useCompactFormLayout = useCompactFormLayout;
    globalPersonalization.accessibilityMode = accessibilityMode;
    // Have to save for other components retrieving from global personalization
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(globalPersonalization);
  }

  private setMenuPersonalization() {
    if (this.lmContextService.isAnonymousUser() || this.lmContextService.getContext().webApp === 'web') {
      this.openOnLarge = false;
      return;
    }

    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    if (!_.isEmpty(bannerPersonalization) && bannerPersonalization.isMenuOpen !== undefined) {
      if (bannerPersonalization.isMenuOpen) {
        if (this.sohoApplicationMenuComponent && !this.sohoApplicationMenuComponent.isOpen()) {
          this.openOnLarge = true;
        }
      } else {
        if (this.sohoApplicationMenuComponent && this.sohoApplicationMenuComponent.isOpen()) {
          this.openOnLarge = false;
        }
      }
    } else {
      const openOnLarge = this.isXiHarness ? true : false;
      if (this.sohoApplicationMenuComponent) {
        this.openOnLarge = openOnLarge;
      }
      bannerPersonalization.isMenuOpen = openOnLarge;
      this.lmGlobalPersonalizationService.saveGlobalPersonalization(bannerPersonalization);
    }
  }

  public toggleMenu() {
    if (this.sohoApplicationMenuComponent.isOpen())  {
      this.sohoApplicationMenuComponent.closeMenu();
    }
    else {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);
        }, 1);
      });
    }
  }

  private isHeaderExpanded(header: any) {
    return header.nativeElement.getElementsByTagName('a')[ 0 ].getAttribute('aria-expanded') === 'true';
  }

  public onHasHeaderTabs(hasHeaderTabs: boolean) {
    this.hasHeaderTabs = hasHeaderTabs;
  }

  public onAppMenuTriggerEvent(event: MouseEvent) {
    if (this.sohoApplicationMenuSearchComponent && this.sohoApplicationMenuSearchComponent.isOpen()) {
      this.onMenuSearchCleared();
    }
  }

  private loadGlobalState() {
    if (this.lmContextService.disablePageState()) {
      this.globalState = {};
      return;
    }

    this.globalState = this.lmGlobalStateService.getGlobalState();
  }

  private saveGlobalState() {
    this.lmGlobalStateService.saveGlobalState(this.globalState);
  }

  /**
   * Sync web app was copied to lmApplicationMenuService
   * Functionality is the same
   * @param url
   * @private
   */
  private syncWebappMenu(url: string) {
    const menuComponent = this.getMenuComponent();

    if (menuComponent.version ===  'v2') {
      this.lmApplicationMenuService.syncWebappMenu(url, menuComponent.component as LMApplicationMenuComponent);
    } else {
      this.lmGlobalUtilService.syncWebappMenu(url, menuComponent.component as LMBannerNavComponent);
    }
  }

  /**
   * Method used to switch between different application menu types
   * @private
   */
  private getMenuComponent(): AppMenuComponent {
    // New Application Menu
    if (this.lmContextService.isApplicationMenuV2()) {
      return {
        version: 'v2',
        component: this.applicationMenuComponent,
        header: this.applicationMenuComponent.webAppMenuHeader,
        loadWebAppMenu: this.applicationMenuComponent.loadWebAppMenu,
        menuSpecs: this.applicationMenuComponent.menuSpecs
      };
    }

    // Original Banner Nav
    return {
      version: 'v1',
      component: this._bannerNavComponent,
      header: this._bannerNavComponent.webAppMenuHeader,
      loadWebAppMenu: this._bannerNavComponent.loadWebAppMenu,
      menuSpecs: this._bannerNavComponent.menuSpecs
    };
  }

  private getSearchMenuComponent(): AppMenuSearchComponent {
    // New Application Menu
    if (this.lmContextService.isApplicationMenuV2()) {
      return {
        version: 'v2',
        component: this.applicationMenuSearchComponent
      };
    }

    // Original Banner Nav
    return {
      version: 'v1',
      component: this._bannerSearchComponent
    };
  }
}
